import React, { useEffect, useState } from 'react';
import '../pages/common.css';

function SuccessMessage({ message, onFadeOut }){
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onFadeOut();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onFadeOut]);

    return visible ? (
        <div className='success-message'>
            {message}
        </div>
    ) : null;
}

export default SuccessMessage;